module.exports = __webpack_public_path__ + "img/vs.8690d3ae.svg";